import AjaxPlugin from 'vux/src/plugins/ajax/index.js'

import qs from 'qs'

AjaxPlugin.$http.defaults.timeout = 30000
AjaxPlugin.$http.defaults.baseURL = process.env.PREFIX

function handlerError(error, code, url) {
if (window.lvyue_report_log && (code === -10000 || code === -9998)) {
const responseMsg = error.response && error.response.status ? `${error.response.status} ${error.response.statusText}` : '-';
window.lvyue_report_log.postAjax({
msg: `接口调用发生错误-${error.message || ''}`,
extra_info: code === -9998 ? error.msg : responseMsg,
url: url || '-'
});
}
}
AjaxPlugin.$http.interceptors.request.use((cfg) => {
const config = {...cfg}
if (config.method === 'post') {
config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
config.data = config.data ? config.data : {}
config.data = qs.stringify(config.data)
} else {
config.params = config.params ? config.params : {}
}

if (config.params && config.params.timeout) {
config.timeout = config.params.timeout;
}

config.headers.fromAgent = 'LVYUE H5 PC';
return config;
}, (error) => {

handlerError(error, -10000, error.config.url)
if (error.response) {
const msg = error.response.status;
console.log(msg)
}
return {};
});



AjaxPlugin.$http.interceptors.response.use((response) => {
if (response.data.code === -9998) {
handlerError(response.data, response.data.code, response.config.url)
}

return response.data;
}, (error) => {

handlerError(error, -10000, error.config.url)
return {};
});

export default AjaxPlugin;



// WEBPACK FOOTER //
// ./src/common/request.js